import React, { useEffect, useState } from "react";
import HeaderWrapper from "../header/HeaderWrapper";
import SideMenu from "./dealComponents/SideMenu";
import DealDashboard from "./dealComponents/DealDashboard";
import "../../assets/styles/loop.css";
import apiAgent from "../../app/api/apiAgent";
import PipelineSales from "./dealComponents/pipelines/PipelineSales";
import DragState from "./DragStore/DragState";
import DealReports from "./dealComponents/DealReports";
import DealGrid from "./dealPages/DealGrid";
import TaskGrid from "./dealPages/TaskGrid";
import { useHistory } from "react-router";
import { useStore } from "../../app/stores/store";

const DealsPage = () => {
  const [sidebarStateVal, setSidebarStateVal] = useState("Dashboard");
  const [pipelinesDD, setPipelinesDD] = useState([]);
  const [pipelinesDDVal, setPipelinesDDVal] = useState("");
  const [pipelineName, setPipelineName] = useState("");
  const [gridFilters, setGridFilters] = useState(null);
  const [actions, setactions] = useState([]);
  const [OwnershipTypes, setOwnershipTypes] = useState([]);
  const [PropertyTypes, setPropertyTypes] = useState([]);
  const [MandateTypes, setMandateTypes] = useState([]);
  const [Agents, setAgents] = useState([]);
  const [FilterCache, setFilterCache] = useState({});
  const [OfficeDD, setOfficeDD] = useState([]);
  const [AgentsRpt, setAgentsRpt] = useState([]);
  const [propertyDD, setPropertyDD] = useState([]);
  const [filterPipelineDD, setFilterPipelineDD] = useState([]);
  const [currencySymbol, setcurrencySymbol] = useState("");
  const [accessType, setAccessType] = useState(null);
  const [statusDD, setstatusDD] = useState([
    {
      text: "Your Workspace",
      value: 1,
    },
    {
      text: "Company's Workspace",
      value: 0,
    },
  ]);
  const [statusDDVal, setstatusDDVal] = useState(statusDD[0].value);
  const history = useHistory();
  const {
    userStore: { userSession },
  } = useStore();

  useEffect(() => {
    if (userSession.role) {
      if (userSession.role == "EntegralSuperUser" || userSession.role == "OfficeAdministrator" || userSession.role == "GroupAdministrator") {
        setAccessType(1);
      } else {
        setAccessType(0);
      }
    } else {
      setAccessType(null);
    }
  }, []);

  useEffect(() => {
    const view = localStorage.getItem("view");
    let pipelineIdStored = localStorage.getItem("pipeline");
    let statusStored = localStorage.getItem("status");
    
    if (!statusStored)
      statusStored = statusDD[0].value;

    if (userSession.role != "EntegralSuperUser" && userSession.role != "OfficeAdministrator" && userSession.role != "GroupAdministrator") {
      statusStored = statusDD[0].value
    }


    console.log("Pipeline: " + pipelineIdStored);
    console.log("Status: " + statusStored);

    apiAgent.Deal.pipelines().then((res) => {

      if (!res.access) {
        history.push("/");
      }

      let pipelineFoundIndex = -1;
      let pipelineNameStored = "";

      if (pipelineIdStored)
        pipelineFoundIndex = res.pipelines.findIndex((curEle) => { return curEle.value == pipelineIdStored });

      if (pipelineFoundIndex == -1)
        pipelineFoundIndex = 0;

      pipelineIdStored = res.pipelines[pipelineFoundIndex].value;
      pipelineNameStored = res.pipelines[pipelineFoundIndex].text;


      setPipelinesDD(res.pipelines);
      setPipelinesDDVal(pipelineIdStored);
      setPipelineName(pipelineNameStored)
      setstatusDDVal(statusStored)
      setcurrencySymbol(res.currency || "");
    });

    apiAgent.Deal.filterData().then((res) => {
      // console.log(res);
      let mandateDD = [];
      let propertyDD = [];
      let pipelineDD = [];

      if (res.MandateTypes.length != 0) {
        mandateDD = res.MandateTypes.map((curMandate) => {
          return { Text: curMandate, Value: curMandate };
        });
      }
      mandateDD.unshift({ Text: "MandateTypes", Value: "" });

      if (res.PropertyTypes.length != 0) {
        res.PropertyTypes.map((propert) => {
          propert.Types?.map((curType) => {
            propertyDD.push({ Text: curType, Value: curType });
          });
        });
      }
      propertyDD.unshift({ Text: "PropertyTypes", Value: "" });

      if (res.PipelinesDD.length != 0) {
        pipelineDD = res.PipelinesDD.map((c) => {
          return { Text: c.Text, Value: c.Value };
        });
      }

      // console.log(res.PipelinesDD);

      pipelineDD.unshift({ Text: "Pipelines", Value: "" });
      // console.log(pipelineDD);

      setPropertyDD(propertyDD);
      setGridFilters(res);
      setactions(res.actions);
      setOwnershipTypes(res.OwnershipTypes);
      setPropertyTypes(res.PropertyTypes);
      setMandateTypes(mandateDD);
      setAgents(res.Agents);
      setFilterCache(res.FilterCache);
      setOfficeDD(res.OfficeDD);
      setAgentsRpt(res.AgentsRpt);
      setFilterPipelineDD(pipelineDD);

      if (view && view != "") {
        setSidebarStateVal(view);
      }
    });

    localStorage.removeItem("view");
  }, []);

  document.title = "Base - Deals";

  return (
    <>
      <HeaderWrapper />
      <div className="dashboard_div">
        <SideMenu sidebarStateVal={sidebarStateVal} setSidebarStateVal={setSidebarStateVal} />

        <div className="col-md-11 component_div">
          <DragState>
            {sidebarStateVal === "Dashboard" && (
              <DealDashboard
                accessType={accessType}
                currencySymbol={currencySymbol}
                pipelineDD={pipelinesDD}
                statusDD={statusDD}
                pipelineState={pipelinesDDVal}
                status={statusDDVal}
                setPipelineState={setPipelinesDDVal}
                setStatus={setstatusDDVal}
                pipelineName={pipelineName}
                setPipelineName={setPipelineName}
              />
            )}
            {sidebarStateVal === "Pipelines" && (
              <PipelineSales
                accessType={accessType}
                currencySymbol={currencySymbol}
                pipelineDD={pipelinesDD}
                statusDD={statusDD}
                pipelineState={pipelinesDDVal}
                status={statusDDVal}
                setPipelineState={setPipelinesDDVal}
                setStatus={setstatusDDVal}
                pipelineName={pipelineName}
                setPipelineName={setPipelineName}
              />
            )}
            {sidebarStateVal === "Deals" && (
              <DealGrid
                actions={actions}
                OwnershipTypes={OwnershipTypes}
                PropertyTypes={PropertyTypes}
                MandateTypes={MandateTypes}
                Agents={Agents}
                FilterCache={FilterCache}
                super_access={gridFilters?.super_access}
                AgentsRpt={AgentsRpt}
                OfficeDD={OfficeDD}
                CurrencyDisplay={gridFilters?.CurrencyDisplay}
                ShowOfficeDD={gridFilters?.ShowOfficeDD}
                pipelineDD={filterPipelineDD}
                currencySymbol={currencySymbol}
              />
            )}
            {sidebarStateVal === "Tasks" && (
              <TaskGrid
                actions={actions}
                OwnershipTypes={OwnershipTypes}
                PropertyTypes={PropertyTypes}
                MandateTypes={MandateTypes}
                Agents={Agents}
                FilterCache={FilterCache}
                super_access={gridFilters?.super_access}
                AgentsRpt={AgentsRpt}
                OfficeDD={OfficeDD}
                CurrencyDisplay={gridFilters?.CurrencyDisplay}
                ShowOfficeDD={gridFilters?.ShowOfficeDD}
                pipelineDD={filterPipelineDD}
                currencySymbol={currencySymbol}
              />
            )}
            {sidebarStateVal === "Reports" && (
              <DealReports
                ref={null}
                ID="dealReports"
                Category="deals"
                super_admin={true}
                MandateTypesRptDD={MandateTypes}
                PropertyTypesRptDD={propertyDD}
                AgentsRptDD={AgentsRpt}
                ShowOfficeDD={gridFilters?.ShowOfficeDD}
                OfficeDD={OfficeDD}
                pipelineDD={filterPipelineDD}
                currencySymbol={currencySymbol}
              />
            )}
          </DragState>
        </div>
      </div>
    </>
  );
};

export default DealsPage;